import React, { useEffect } from 'react';
import MetricCard from './MetricCard';
import { useGymCustomer } from '../../DataStore/Gym/GymCustomerContext';
import { useGym } from '../../DataStore/Gym/GymContext';
import functions from '../../util/functions';

const MetricSection = () => {
    const {getGymCustomerCount, GymCustomerCount} = useGymCustomer();
    const {getMonthlyRevenue, monthlyRevenue, getDailySessionCount, dailySessionCount} = useGym();

    useEffect(() => {
        getGymCustomerCount();
        getMonthlyRevenue();
        getDailySessionCount();
    }
    , []);

    return (
        <>
         <div className="row mb-0 small-gutters">
          {/* Revenue */}
          <div className="col-md-6 col-lg-6">
          <MetricCard 
            iconClass="fa fa-chart-line"
            iconBg="bg-focus"
            title={`${new Date().toLocaleString('default', { month: 'long' })} Revenue`}
            value={`UGX ${monthlyRevenue ? functions.numberFormat(monthlyRevenue.total_billed) : '...'}`}
            trendText="Collection"
            trendDirection='up'
            trendPercentage={monthlyRevenue ? functions.numberFormat(monthlyRevenue.total_paid) : '...'}
          />

          </div>

          {/* Members */}
          <div className="col-md-6 col-lg-6">
            <MetricCard 
              iconClass="fa fa-user"
              iconBg="bg-primary"
              title="Customers"
              value={GymCustomerCount}
              trendText="Active Members"
            />
          </div>
          </div>
        <div className="row small-gutters">

          {/* Visited */}
          <div className="col-md-6 col-lg-6">
            <MetricCard 
              iconClass="fa fa-clock"
              iconBg="bg-warning"
              title="Daily Sessions"
              value={dailySessionCount ? dailySessionCount.total_p : '...'}
              trendText="Gym sessions today"
            />
          </div>

          {/* Trainer */}
          <div className="col-md-6 col-lg-6">
            <MetricCard 
              iconClass="fa fa-user-friends"
              iconBg="bg-success"
              title="Trainers"
              value="03"
              trendText="Active Trainers"
            />
          </div>
        </div>
        </>
    );
};

export default MetricSection;